import React, { useState, useEffect } from 'react'
import { Tag, Tooltip } from 'antd'

const RenderTime = ({ processingAt, colorMerge, mergeFileStatus, mergeFileJob, needConvertCmyk }) => {
    const [formattedTime, setFormattedTime] = useState({})
    const [hovering, setHovering] = useState(false)

    const timeRender = () => {
        const { processing_at, converting_at, completed_at, error_message } = mergeFileJob
        const processTime = new Date(processing_at)
        const convertingTime = new Date(converting_at)
        const completeTime = new Date(completed_at)

        const endTime = new Date()

        if(!needConvertCmyk && mergeFileStatus !== 'error') return {processingTime: calculateTime(endTime - processTime)}

        switch (mergeFileStatus) {
            case 'processing':
            case 'ready':
                return {
                    processingTime: calculateTime(endTime - processTime).trim()
                }
            case 'converting':
                return {
                    processingTime: calculateTime(convertingTime - processTime).trim(),
                    convertTime: calculateTime(endTime - convertingTime).trim(),
                }
            case 'done':
                return {
                    processingTime: calculateTime(convertingTime - processTime).trim(),
                    convertTime: calculateTime(completeTime - convertingTime).trim(),
                }
            case 'error':
                return { error: error_message }
            default:
                return {}
        }
    }

    const calculateTime = (time) => {
        if (!time) return ''

        const hours = Math.floor(time / (1000 * 60 * 60))
        const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((time % (1000 * 60)) / 1000)

        return `${!!hours ? String(hours).padStart(2, '0') + 'h' : ''} ${!!minutes ? String(minutes).padStart(2, '0') + 'm' : ''} ${!!seconds ? String(seconds).padStart(2, '0') + 's' : ''}`
    }

    const content = () => {
        const { processingTime = '', convertTime = '', error = '' } = formattedTime
        if (!!error) return <span>{error}</span>

        return (
            <>
                {!!processingTime && <div>Thời gian xử lý: {processingTime}</div>}
                {!!convertTime && <div>Thời gian convert CMYK: {convertTime}</div>}
            </>
        )
    }

    useEffect(() => {
        if (hovering) {
            setFormattedTime(timeRender())
        }
    }, [hovering, processingAt])

    return (
        (['processing', 'error', 'converting'].includes(mergeFileStatus)) ?
            <Tooltip
                title={content()}
                placement='topLeft'
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
            >
                <span className={`badge cursor-pointer ${colorMerge} badge-pill`}>{mergeFileStatus}</span>
            </Tooltip> :
            <span className={`badge cursor-pointer ${colorMerge} badge-pill`}>{mergeFileStatus}</span>
    )
}

export default RenderTime